// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__P_MyC","header":"PatientBlock_header__gw0Yi","label":"PatientBlock_label__3Szqg","option":"PatientBlock_option__3Jhwj"};